import axios from 'axios';

function assertMessagingSuccess(data) {
  if (data?.result === 0) {
    const error = new Error(data.msg || 'Request failed');
    error.response = {
      status: data?.data?.retryAfterSeconds ? 429 : undefined,
      data,
    };
    throw error;
  }
  return data;
}

/**
 * Email OTP / verification code (Hostinger SMTP / SendGrid / Resend on backend).
 * @param {{ email: string, purpose?: 'login' | 'register' | 'forgotPassword' }} payload
 */
export async function resendOtpByEmail({ email, purpose = 'login' }) {
  const { data } = await axios.post('/users/resend-otp', {
    email: email.trim(),
    purpose,
  });
  return assertMessagingSuccess(data);
}

/**
 * SMS OTP via Twilio on backend.
 * @param {{ phone: string, purpose?: 'login' | 'register' | 'forgotPassword' }} payload — 10-digit mobile
 */
export async function resendOtpByPhone({ phone, purpose = 'login' }) {
  const { data } = await axios.post('/users/resend-otp', {
    phone,
    channel: 'sms',
    purpose,
  });
  return assertMessagingSuccess(data);
}

/**
 * WhatsApp OTP via Twilio on backend (sandbox or approved template).
 * @param {{ phone: string, purpose?: 'login' | 'register' | 'forgotPassword' }} payload — 10-digit mobile
 */
export async function resendOtpByWhatsApp({ phone, purpose = 'login' }) {
  const digits = String(phone).replace(/\D/g, '').slice(-10);
  const { data } = await axios.post('/users/resend-otp', {
    phone: digits,
    channel: 'whatsapp',
    purpose,
  });
  return assertMessagingSuccess(data);
}

/**
 * Resend OTP or email code depending on payload.
 * @param {{ email?: string, phone?: string, channel?: 'sms' | 'whatsapp', purpose?: 'login' | 'register' | 'forgotPassword' }} payload
 */
export async function resendOtp(payload) {
  const body = { purpose: 'login', ...payload };
  if (body.phone) {
    const digits = String(body.phone).replace(/\D/g, '').slice(-10);
    if (digits.length === 10) body.phone = digits;
  }
  const { data } = await axios.post('/users/resend-otp', body);
  return assertMessagingSuccess(data);
}

/**
 * Verify OTP or email code.
 * @param {{ phone?: string, email?: string, otp: number, type: 'verifyPhone' | 'verifyEmail' | 'forgotPassword', channel?: 'sms' | 'whatsapp' | 'email' }} payload
 */
export async function verifyOtp(payload) {
  const { data } = await axios.post('/users/otp-verify', payload);
  return assertMessagingSuccess(data);
}
